/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Contactmethods1Inputs */

const he_contact_contactmethods1 = /** @type {(inputs: Contact_Contactmethods1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דרכי התקשרות`)
};

const en_contact_contactmethods1 = /** @type {(inputs: Contact_Contactmethods1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Methods`)
};

/**
* | output |
* | --- |
* | "Contact Methods" |
*
* @param {Contact_Contactmethods1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_contactmethods1 = /** @type {((inputs?: Contact_Contactmethods1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Contactmethods1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_contactmethods1(inputs)
	return en_contact_contactmethods1(inputs)
});
export { contact_contactmethods1 as "contact_contactMethods" }